import { graphql } from 'gql/generated/gql'

export const CREATE_SERVICE_VEHICLE_OVERRIDE = graphql(`
  mutation CreateServiceVehicleOverride($input: CreateRouteServiceVehicleOverrideInput!) {
    createRouteServiceVehicleOverride(input: $input)
  }
`)

export const CREATE_SERVICE_PAST_VEHICLE_OVERRIDE = graphql(`
  mutation CreateServicePastVehicleOverride($input: CreateRouteServicePastVehicleOverrideInput!) {
    createRouteServicePastVehicleOverride(input: $input)
  }
`)

export const CREATE_SERVICE_DRIVER_OVERRIDE = graphql(`
  mutation CreateServiceDriverOverride($input: CreateRouteServiceDriverOverrideInput!) {
    createRouteServiceDriverOverride(input: $input)
  }
`)

export const CREATE_SERVICE_ITINERARY_OVERRIDE = graphql(`
  mutation CreateServiceItineraryOverride($input: CreateRouteServiceItineraryOverrideInput!) {
    createRouteServiceItineraryOverride(input: $input)
  }
`)

export const CREATE_SERVICE_ROUTE_OVERRIDE = graphql(`
  mutation CreateServiceRouteOverride($input: CreateRouteServiceRouteOverrideInput!) {
    createRouteServiceRouteOverride(input: $input)
  }
`)
